<template>
  <div
    class="flex size-full items-center justify-center rounded-xl md:h-[70vh]"
    role="progressbar"
  >
    <div class="absolute left-0 top-0 size-full rounded-xl" />
    <div class="z-40 flex w-fit flex-col items-center justify-center px-8">
      <UiLoader />
      Загрузка схемы
    </div>
  </div>
</template>
